import { FAQItem } from "./FAQ.d";

export const faqList: FAQItem[] = [];
